export default __webpack_public_path__ + "static/media/pruthvi.d2705475.jpg";